exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-ea5e93c0]{padding:25px}.button-control[data-v-ea5e93c0]{text-align:right;padding-right:16px}h2[data-v-ea5e93c0]{font-weight:700;margin-bottom:25px;margin-top:25px}.question-title[data-v-ea5e93c0]{font-size:20px;font-weight:700}.question-choice[data-v-ea5e93c0]{margin-top:20px;margin-bottom:20px}.radio[data-v-ea5e93c0]{font-size:18px}", ""]);

// exports
